import { Concept, PackAttachment, Representation } from "../Types";
import {
  SyntheticEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { EditableText } from "./EditableText";
import { ModalityPill } from "./ModalityPill";

type RepProps = {
  fields: string[];
  name: string;
  fullName: string | undefined;
  rep: Representation;
  selected: boolean;
  selection: [number, number, number] | undefined;
  updateRepField: (repKey: string, fieldKey: string, value: any) => void;
  removeRepCb: (repKey: string) => void;
  setSelection: (repKeyIndex: number) => void;
  isAiSuggestion: boolean;
  onEditKey?: (repKey: string) => void;
  showPlaceholder?: boolean;

  attachments: PackAttachment[];
};

export default function RepView(props: RepProps) {
  const {
    showPlaceholder,
    rep,
    name,
    fullName,
    updateRepField,
    removeRepCb,
    setSelection,
    fields,
    selected,
    selection,
    isAiSuggestion,
    onEditKey,
    attachments,
  } = props;
  const removeCb = useCallback(() => {
    removeRepCb(name);
  }, [name, removeRepCb]);

  const updateFieldCb = (fieldKey: string) => (event: SyntheticEvent) => {
    updateRepField(name, fieldKey, (event.target as HTMLTextAreaElement).value);
  };

  const updateFieldTextCb = (fieldKey: string) => (value: string | null) => {
    updateRepField(name, fieldKey, value);
  };

  const refs = {} as { [key: string]: HTMLTextAreaElement };

  useEffect(() => {
    if (!selected) {
      return;
    }
    refs[selection![2]]?.click();
    refs[selection![2]]?.focus();
    console.log("change relevant selection", selection, refs[selection![2]]);
  }, [selected, selection, refs.current]);

  const onFocusId = useCallback(
    () => {
      setSelection(-1);
      // console.log("focus", name);
      // setSelection(0);
    },
    [selected, selection],
  );

  const onFocusFirst = useCallback(() => {
    setSelection(0);
  }, [selected, selection]);

  const onFocusSecond = useCallback(() => {
    setSelection(1);
  }, [selected, selection]);

  const onFocusThird = useCallback(() => {
    setSelection(2);
  }, [selected, selection]);

  const onFocusFourth = useCallback(() => {
    setSelection(3);
  }, [selected, selection]);

  const onFocusFifth = useCallback(() => {
    setSelection(4);
  }, [selected, selection]);

  const getOnFocus = (index: number) => {
    switch (index) {
      case 0:
        return onFocusFirst;
      case 1:
        return onFocusSecond;
      case 2:
        return onFocusThird;
      case 3:
        return onFocusFourth;
      case 4:
        return onFocusFifth;
    }
  };

  const onInput = useCallback(() => {
  }, []);

  // ▼ ▶︎
  return (
    <tr>
      <td>
        {onEditKey
          ? (
            <EditableText
              onFocus={onFocusId}
              toggleEdit={false}
              value={name}
              write={onEditKey}
            />
          )
          : fullName}
      </td>

      {fields.map((field, index) => {
        const value = rep[field] || "";
        return (
          <td key={field}>
            {(field === "image" || field === "audio")
              ? (
                <ModalityPill
                  modality={field}
                  value={value}
                  attachments={attachments.filter((a) =>
                    a.type.startsWith(field)
                  )}
                  setValue={(value: string | null) => {
                    updateFieldTextCb(field)(value);
                  }}
                />
              )
              : (
                <textarea
                  ref={(ref) => refs[index] = ref!}
                  value={value}
                  placeholder={showPlaceholder ? field : undefined}
                  onFocus={getOnFocus(index)}
                  onInput={updateFieldCb(field)}
                  // onBlur={getCallback(field)}
                  className={`noticeable${
                    isAiSuggestion ? " ai-suggestion" : ""
                  }`}
                />
              )}
          </td>
        );
      })}

      <td>
        <button className="close-btn" onClick={removeCb}>
          -
        </button>
      </td>
    </tr>
  );
}
